import React, { useState, forwardRef } from 'react';
import styles from './GlobalInput.module.css';

interface GlobalInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}

export const GlobalInput = forwardRef<HTMLInputElement, GlobalInputProps>(
  ({ label, error, className, value, ...props }, ref) => {
    const [isFocused, setIsFocused] = useState(false);

    const hasValue =
      value !== undefined && value !== null
        ? String(value).length > 0
        : false;

    const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
      setIsFocused(true);
      props.onFocus?.(e);
    };

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
      setIsFocused(false);
      props.onBlur?.(e);
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      props.onChange?.(e);
    };

    return (
      <div className={`${styles.inputContainer} ${className || ''}`}>
        <div className={styles.inputWrapper}>
          <input
            {...props}
            ref={ref}
            value={value}
            className={`${styles.input} ${error ? styles.error : ''} ${isFocused ? styles.focused : ''} ${hasValue ? styles.hasValue : ''}`}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={handleChange}
            placeholder=" "
          />
          <label className={styles.label}>{label}</label>
        </div>
        {error && <span className={styles.errorMessage}>{error}</span>}
      </div>
    );
  }
);

GlobalInput.displayName = 'GlobalInput';
